angular.module("gifts_reports")

    .controller("GiftsReportsCtrl", ['$scope', '$rootScope', '$controller', '$state', 'Restangular', '$uibModal', 'modalService', '$filter', 'uiGridConstants', 'gridService',
        function ($scope, $rootScope, $controller, $state, Restangular, $uibModal, modalService, $filter, uiGridConstants, gridService) {

            $rootScope.title = $filter('translate')('gifts_reports.title');

            $scope.gifts_reports = {
                person: {},
                gift: {}
            };

            $scope.total = 0;
            $scope.showGiftsReport = false;

            Restangular.all('Persons/AllPersons').getList().then(function (persons) {
                $scope.selectPersons = persons;
                $scope.selectPersons.unshift({
                    id: null,
                    name: $filter('translate')('gifts_reports.all')
                });
                $scope.gifts_reports.person = $scope.selectPersons[0];
            });

            $scope.limit = 50;

            /*$scope.select2Options = {
                query: function (query) {
                    var data = { results: [], more: false };
                    logService.debug("aa");
                    // Reduce all values to what's needed
                    if ($scope.selectPersons) {
                        // Filter search
                        data.results = $scope.selectPersons.reduce(function (previous, current) {
                            if (query.matcher(query.term, current.text)) {
                                previous.push(current);
                            }
                            return previous;
                        }, []);
                        // Page
                        if (data.results.length > query.page * $scope.limit) {
                            data.more = true;
                        }
                        data.results = data.results.splice((query.page - 1) * $scope.limit, $scope.limit);
                    }
                    query.callback(data);
                },
                multiple: true
            };*/

            Restangular.all('Gifts').getList().then(function (gifts) {
                $scope.selectGifts = gifts;
                $scope.selectGifts.unshift({
                    id: null,
                    name: $filter('translate')('gifts_reports.all')
                });
                $scope.selectGifts.push({
                    id: 0,
                    name: $filter('translate')('gifts_reports.other_gifts')
                });
                $scope.gifts_reports.gift = $scope.selectGifts[0];
            });

            $scope.generateReport = function () {

                $scope.showGiftsReport = true;

                if (angular.isDefined($scope.gridOptionsGifts)) {
                    $scope.gridOptionsGifts.loadData(false);
                } else {
                    $scope.gridOptionsGifts = {
                        showColumnFooter: true,
                        exporterMenuCsv: true,
                        enableGridMenu: true,
                        enableHiding: false,
                        gridMenuShowHideColumns: true,
                        paginationPageSizes: [15, 30, 45],
                        paginationPageSize: 15,
                        onRegisterApi: function (gridApi) {
                            this.gridApi = gridApi;
                        },
                        pdfTitle: $filter('translate')('tasks_reports.pdf_title'),
                        getFilterExternalDescription: function () {
                            var externalFilters = "";
                            if (angular.isDefined($scope.gifts_reports.person) && $scope.gifts_reports.person.id != null)
                                externalFilters += $filter('translate')('gifts_reports.person') + ": " + $scope.gifts_reports.person.name + "\n";
                            if (angular.isDefined($scope.gifts_reports.gift) && $scope.gifts_reports.gift.id != null)
                                externalFilters += $filter('translate')('gifts_reports.gift') + ": " + $scope.gifts_reports.gift.name + "\n";
                            if ($scope.gifts_reports.date_from != null && $scope.gifts_reports.date_from != "") {
                                var fecha = $scope.gifts_reports.date_from;
                                externalFilters += "\n" + $filter('translate')('gifts_reports.date_from') + ": " + fecha.getDate() + "/" + fecha.getMonth() + "/" + fecha.getFullYear();
                            }
                            if (angular.isDefined($scope.gifts_reports.in_out) && $scope.gifts_reports.in_out != "")
                                externalFilters += $filter('translate')('gifts_reports.in_out') + ": " + $scope.gifts_reports.in_out == 'IN' ? $filter('translate')('gifts_reports.in') : $filter('translate')('gifts_reports.out') + "\n";
                            if ($scope.gifts_reports.date_to != null && $scope.gifts_reports.date_to != "") {
                                var fecha = $scope.gifts_reports.date_to;
                                externalFilters += "\n" + $filter('translate')('gifts_reports.date_to') + ": " + fecha.getDate() + "/" + fecha.getMonth() + "/" + fecha.getFullYear();
                            }
                            externalFilters += "\n\n" + "Coste total: " + $scope.total + "€ \n";
                            return externalFilters;
                        },
                        columnDefs: [
                          { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                          {
                              name: 'gift_date', displayName: $filter('translate')('gifts_reports.date'), cellFilter: 'toLocalDate | date:\'dd/MM/yyyy\'',
                              enableFiltering: true, enableColumnMenu: false, width: 150,
                              customFormatFn: function (value) {
                                  var fecha = new Date(value);
                                  return $filter('date')(fecha, 'dd/MM/yyyy');
                              },
                          },
                          {
                              name: 'in_out', displayName: $filter('translate')('gifts_reports.in_out'), enableFiltering: true,
                              cellTemplate: '<div class="ui-grid-cell-contents" ng-if="row.entity.in_out == \'IN\'">'+$filter('translate')('gifts_reports.in')+'</div>' +
                                '<div class="ui-grid-cell-contents" ng-if="row.entity.in_out == \'OUT\'">' + $filter('translate')('gifts_reports.out') + '</div>',
                              customFormatFn: function (value) {
                                  if (value == 'IN')
                                      return $filter('translate')('gifts_reports.in');
                                  else if (value == 'OUT')
                                      return $filter('translate')('gifts_reports.out');
                                  else
                                      return value
                              },
                          },
                          { name: 'person_name', field: 'FK_persons_gifts_persons.name', displayName: $filter('translate')('gifts_reports.person_name'), enableFiltering: true },
                          { name: 'person_surname', field: 'FK_persons_gifts_persons.surname', displayName: $filter('translate')('gifts_reports.person_surname'), enableFiltering: true },
                          { name: 'person_lastname', field: 'FK_persons_gifts_persons.lastname', displayName: $filter('translate')('gifts_reports.person_lastname'), enableFiltering: true },
                          { name: 'event_name', field: 'FK_persons_gifts_events.name', displayName: $filter('translate')('gifts_reports.event'), enableFiltering: false },
                          { name: 'gift_name', field: 'name', displayName: $filter('translate')('gifts_reports.gift'), enableFiltering: false, enableHiding: false },
                          { name: 'quantity', displayName: $filter('translate')('gifts_reports.quantity'), enableFiltering: true },
                          { name: 'cost', displayName: $filter('translate')('gifts_reports.cost'), enableFiltering: true, footerCellTemplate: '<div class="ui-grid-cell-contents">Total: {{grid.appScope.total}} €</div>' },
                          { name: 'grateful', width: 100, field: 'grateful', displayName: $filter('translate')('persons_gifts.grateful'), enableFiltering: false, cellTemplate: gridService.yesNoTemplate('grateful') },
                          { name: 'given_to_somebody', width: 100, field: 'given_to_somebody', displayName: $filter('translate')('persons_gifts.given_to_somebody'), enableFiltering: false, cellTemplate: gridService.yesNoTemplate('given_to_somebody') },
                          { name: 'given_to', displayName: $filter('translate')('persons_gifts.given_to'), enableFiltering: false },
                        ],
                        getData: function (options) {
                            options.in_out = $scope.gifts_reports.in_out;
                            options.date_from = $scope.gifts_reports.date_from;
                            options.date_to = $scope.gifts_reports.date_to;
                            options.gift_id = $scope.gifts_reports.gift.id;
                            options.person_id = (typeof($scope.gifts_reports.person) !== 'undefined' && $scope.gifts_reports.person != null ? $scope.gifts_reports.person.id : null);
                            Restangular.all('Reports/Gifts/TotalCost').getList(options).then(function (total) {
                                $scope.total = total[0];
                            });

                            return Restangular.all('Reports/Gifts').getList(options);
                        }

                    };
                }
            }

        }])

;